import React, {useState} from 'react';
import {useIntl} from 'react-intl';
import Util from '../../../shared/util/util';
import SharedReportLoginMutation from '../../../../mutations/shared_report_login_mutation';

const SharedReportLogin = ({sharedId, refetch}) => {
	const {formatMessage} = useIntl();

	const [error, setError] = useState(null);

	const [password, setPassword] = useState(null);

	const handleSubmit = event => {
		if (event) {
			event.preventDefault();
		}

		if (!password || !password.length) {
			//TODO - I18N
			setError('Please enter the password');
			return;
		}

		const onSuccess = ({sharedReportLogin}) => {
			if (sharedReportLogin && sharedReportLogin.success && sharedReportLogin.errors === null) {
				refetch();
			} else {
				// TODO - I18N
				if (sharedReportLogin.errors) {
					if (sharedReportLogin.errors.includes('07-001-001')) {
						// Wrong password
						setError('Sorry, it seems like the password is incorrect or the report is unavailable');
						return;
					} else if (sharedReportLogin.errors.includes('06-002-001')) {
						// Share not available
						setError('Sorry, it seems like the password is incorrect or the report is unavailable');
						return;
					}
				}

				setError('An error occurred while trying to get the report');
			}
		};

		Util.CommitMutation(
			SharedReportLoginMutation,
			{
				sharedId,
				password,
			},
			onSuccess,
			true,
			true,
		);
	};

	return (
		<div className="fullscreen fullscreen-centered-outer login login-bg">
			<div className="logo" />
			<div className="fullscreen-centered-inner">
				<div className="fullscreen-centered-content form-vertical">
					<form onSubmit={handleSubmit}>
						<h1>{formatMessage({id: 'login.report.title'})}</h1>
						<div data-cy="password-label" className="fieldset">
							<input
								type="password"
								onChange={e => setPassword(e.target.value)}
								placeholder={formatMessage({id: 'login.enter-password'})}
							/>
							{error ? <div className="error">{error}</div> : ''}
						</div>

						<div data-cy="login-button" className="buttons">
							<input type="submit" value={formatMessage({id: 'login.log-in'})} className={'btn btn-pull-right'} />
						</div>
					</form>
				</div>
			</div>
		</div>
	);
};

export default SharedReportLogin;
